<div class="volunteer-detail-page">

  @if (isLoading) {
    <div class="detail-loading">
      Cargando información completa del expediente...
    </div>
  } @else if (errorMessage) {
    <div class="detail-error">
      {{ errorMessage }}
    </div>
  } @else if (volunteer) {

    <!-- VOLVER -->
    <a class="back-link" routerLink="/student">
      ← Volver a voluntarios
    </a>

    <!-- =========================
         HERO
    ========================== -->
    <section class="volunteer-hero">
      <div class="hero-top-row">
        <div class="hero-main">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 6px; flex-wrap: wrap;">
            <span class="eyebrow" style="margin-bottom: 0;">
              EXPEDIENTE DEL VOLUNTARIO
            </span>
            <span class="hero-type-pill">
              VOLUNTARIO GENERAL
            </span>

            @if (volunteer.accountStatus === 'pending') {
              <span class="status-pill pill-pending">⏳ Pendiente de Aceptación</span>
            } @else if (volunteer.accountStatus === 'rejected') {
              <span class="status-pill pill-rejected">✕ Rechazado</span>
            }
          </div>

          <div style="display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 4px;">
            <h1 style="margin: 0;">
              {{ volunteer.fullName }}
            </h1>
            @if (volunteer.folio) {
              <button
                type="button"
                class="hero-folio-btn"
                [class.is-copied]="isFolioCopied"
                (click)="copyFolioToClipboard($event)"
                [attr.aria-label]="isFolioCopied ? 'Folio copiado al portapapeles' : 'Copiar folio al portapapeles'"
                [title]="isFolioCopied ? '¡Copiado!' : 'Clic para copiar folio al portapapeles'"
              >
                @if (isFolioCopied) {
                  <span class="folio-copied-content">
                    <span class="material-symbols-outlined folio-check-icon">check_circle</span>
                    <span class="folio-copied-text">¡Folio copiado!</span>
                  </span>
                } @else {
                  <span class="folio-default-content">
                    <span class="folio-label">FOLIO:</span>
                    <span class="folio-code">{{ volunteer.folio }}</span>
                    <span class="material-symbols-outlined folio-copy-icon">content_copy</span>
                  </span>
                }
              </button>
            }
          </div>

          <p>
            {{ volunteer.mail || 'Sin correo registrado' }}
          </p>
        </div>

        @if (volunteer.accountStatus === 'active') {
          <div class="hero-actions">
            <button
              type="button"
              class="btn-inactivate-hero"
              (click)="openInactivateModal()"
              title="Inactivar cuenta por decisión administrativa"
            >
              <span class="material-symbols-outlined">person_off</span>
              <span>Inactivar Cuenta</span>
            </button>
          </div>
        }
      </div>

      <!-- FILA DE STATS / INFORMACIÓN Y MÉTRICAS DEL EXPEDIENTE INTEGRADA EN EL GRADIENTE -->
      <div class="hero-stats-row">
        <div class="hero-stat-card">
          <span class="hero-stat-label">ESTATUS</span>
          <div class="hero-stat-value">
            @if (volunteer.accountStatus === 'pending') {
              <strong class="status-pending" style="color: #fde047;">⏳ Pendiente</strong>
            } @else if (volunteer.accountStatus === 'rejected') {
              <strong class="status-rejected" style="color: #fca5a5;">✕ Rechazado</strong>
            } @else {
              <strong class="status-active" style="color: #86efac;">● Activo</strong>
            }
          </div>
          <small class="hero-stat-sub">Estado actual de acceso</small>
        </div>

        <div class="hero-stat-card hero-stat-card-combined">
          <div class="combined-stat-col">
            <span class="hero-stat-label">EMISIÓN DE EXPEDIENTE</span>
            <strong class="hero-stat-value">
              {{ volunteer.fechaEmisionExpediente ? (volunteer.fechaEmisionExpediente | date:'dd/MM/yyyy HH:mm') : 'N/A' }}
            </strong>
            <small class="hero-stat-sub">Finalización de formulario</small>
          </div>

          <div class="combined-stat-divider"></div>

          <div class="combined-stat-col">
            <span class="hero-stat-label">ACEPTACIÓN / EXPEDICIÓN</span>
            <strong class="hero-stat-value" [style.color]="volunteer.accountStatus === 'active' ? '#86efac' : 'rgba(255, 255, 255, 0.9)'">
              {{ (volunteer.fechaAceptacionExpediente || volunteer.fechaExpedicionExpediente) ? ((volunteer.fechaAceptacionExpediente || volunteer.fechaExpedicionExpediente) | date:'dd/MM/yyyy HH:mm') : (volunteer.accountStatus === 'pending' ? 'Pendiente' : 'N/A') }}
            </strong>
            <small class="hero-stat-sub">Validación de ABAQ</small>
          </div>
        </div>

        <div class="hero-stat-card">
          <span class="hero-stat-label">OPORTUNIDADES GENERADAS</span>
          <strong class="hero-stat-value">
            {{ opportunitiesCount }}
            <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
              {{ opportunitiesCount === 1 ? 'oportunidad' : 'oportunidades' }}
            </span>
          </strong>
          <small class="hero-stat-sub">Vinculaciones registradas</small>
        </div>

        <div class="hero-stat-card">
          <span class="hero-stat-label">ACTIVIDADES</span>
          <strong class="hero-stat-value">
            {{ activitiesCount }}
            <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
              {{ activitiesCount === 1 ? 'actividad' : 'actividades' }}
            </span>
          </strong>
          <small class="hero-stat-sub">Participación en programas</small>
        </div>

        <div class="hero-stat-card hero-stat-card-total">
          <span class="hero-stat-label">SUMA TOTAL</span>
          <strong class="hero-stat-value">
            {{ totalStatsCount }}
            <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
              {{ totalStatsCount === 1 ? 'registro' : 'registros' }}
            </span>
          </strong>
          <small class="hero-stat-sub">Oportunidades + actividades</small>
        </div>
      </div>
    </section>

    @if (statusFeedback) {
      <div
        class="status-feedback-alert"
        [ngClass]="statusFeedback.startsWith('Error') ? 'alert-danger' : 'alert-success'"
      >
        {{ statusFeedback }}
      </div>
    }

    @if (profileSuccess) {
      <div class="status-feedback-alert alert-success">
        {{ profileSuccess }}
      </div>
    }

    @if (profileError) {
      <div class="status-feedback-alert alert-danger">
        {{ profileError }}
      </div>
    }

    <!-- BANNER DE APROBACIÓN DE VOLUNTARIO GENERAL -->
    @if (volunteer.accountStatus === 'pending') {
      <div class="pending-approval-banner">
        <div class="banner-content">
          <div class="banner-icon-box">
            <span class="material-symbols-outlined">how_to_reg</span>
          </div>
          <div class="banner-texts">
            <div class="banner-kicker">SOLICITUD DE INGRESO · VOLUNTARIADO GENERAL</div>
            <h3>Nuevo voluntario general pendiente de aceptación</h3>
            <p>
              {{ volunteer.fullName }} completó su proceso de onboarding y registro y su expediente está esperando validación de la Coordinación de ABAQ. Al aceptarlo, se activará su cuenta, se generará su constancia oficial con código QR y se le dará ingreso formal al sistema.
            </p>
          </div>
        </div>

        <div class="banner-action-buttons">
          <button
            type="button"
            class="btn-accept-volunteer"
            (click)="acceptVolunteer()"
            [disabled]="isAccepting"
            title="Aceptar e ingresar voluntario general"
          >
            <span class="material-symbols-outlined">check</span>
            @if (isAccepting) {
              Aceptando...
            } @else {
              Aceptar Voluntario y Activar
            }
          </button>

          <button
            type="button"
            class="btn-reject-volunteer"
            (click)="rejectVolunteer()"
            [disabled]="isRejecting || isAccepting"
            title="Rechazar solicitud de ingreso"
          >
            <span class="material-symbols-outlined">close</span>
            @if (isRejecting) {
              Rechazando...
            } @else {
              Rechazar
            }
          </button>
        </div>
      </div>
    }

    <!-- BITÁCORA DE ESTATUS / BAJA (Fase C4.1) -->
    @if (volunteer.accountStatus === 'inactive') {
      <div class="inactive-reason-banner">
        <span class="material-symbols-outlined">block</span>
        <div>
          <span class="inactive-banner-title">Cuenta dada de baja (inactiva)</span>
          <span class="inactive-banner-reason">
            Causal: {{ getFriendlyReason(lastStatusChange?.reason) }}
          </span>
          @if (lastStatusChange?.comments) {
            <p class="inactive-banner-comments">
              {{ lastStatusChange.comments }}
            </p>
          }
          @if (lastStatusChange?.date) {
            <span class="status-history-date">
              {{ lastStatusChange.date | date:'dd/MM/yyyy HH:mm' }}
            </span>
          }
        </div>
      </div>
    } @else if (lastStatusChange) {
      <div class="status-history-note">
        <span class="status-history-title">Última transición de estatus</span>
        <span class="status-history-reason">
          {{ getFriendlyReason(lastStatusChange.reason) }}
        </span>
        @if (lastStatusChange.comments) {
          <p class="status-history-comments">
            {{ lastStatusChange.comments }}
          </p>
        }
        @if (lastStatusChange.date) {
          <span class="status-history-date">
            {{ lastStatusChange.date | date:'dd/MM/yyyy HH:mm' }}
          </span>
        }
      </div>
    }

    <!-- BARRA DE ACCIÓN DE EDICIÓN DEL ADMINISTRADOR -->
    <div style="display: flex; justify-content: flex-end; margin-bottom: 24px; gap: 12px;">
      @if (!isEditing) {
        <button
          type="button"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 18px; border-radius: 10px; background: #24366f; color: #ffffff; border: none; font-weight: 700; font-size: 13.5px; cursor: pointer; box-shadow: 0 2px 8px rgba(36, 54, 111, 0.2);"
          (click)="startEdit()"
        >
          <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
          Modificar datos del voluntario
        </button>
      } @else {
        <button
          type="button"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 18px; border-radius: 10px; background: #e2e8f0; color: #334155; border: 1px solid #cbd5e1; font-weight: 700; font-size: 13.5px; cursor: pointer;"
          (click)="cancelEdit()"
          [disabled]="isSaving"
        >
          Cancelar
        </button>
        <button
          type="button"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; border-radius: 10px; background: #059669; color: #ffffff; border: none; font-weight: 700; font-size: 13.5px; cursor: pointer; box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);"
          (click)="saveVolunteer()"
          [disabled]="isSaving"
        >
          @if (isSaving) {
            Guardando cambios...
          } @else {
            ✓ Guardar cambios
          }
        </button>
      }
    </div>

    <!-- =========================
         DATOS PERSONALES Y CONTACTO
    ========================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">PERFIL</span>
          <h2>Información del voluntario</h2>
          <p>Datos registrados en el expediente.</p>
        </div>
      </div>

      @if (!isEditing) {
        <div class="info-grid">
          <article class="info-card">
            <span>FOLIO DE EXPEDIENTE</span>
            <strong style="font-family: monospace; font-weight: 750; color: #1e3a8a;">
              {{ volunteer.folio || '—' }}
            </strong>
          </article>

          <article class="info-card">
            <span>NOMBRE COMPLETO</span>
            <strong>{{ volunteer.fullName }}</strong>
          </article>

          <article class="info-card">
            <span>CORREO ELECTRÓNICO</span>
            <strong>{{ volunteer.mail || 'No registrado' }}</strong>
          </article>

          <article class="info-card">
            <span>TELÉFONO PRINCIPAL</span>
            <strong>{{ volunteer.phone || 'No registrado' }}</strong>
          </article>

          <article class="info-card">
            <span>CLAVE ÚNICA DE REGISTRO (CURP)</span>
            <strong style="font-family: monospace;">{{ volunteer.curp || 'No registrada' }}</strong>
          </article>

          <article class="info-card">
            <span>OCUPACIÓN / OFICIO</span>
            <strong>{{ volunteer.occupation || 'No especificada' }}</strong>
          </article>

          <article class="info-card">
            <span>FECHA DE NACIMIENTO</span>
            <strong>
              {{ volunteer.birthDate ? (volunteer.birthDate | date:'dd/MM/yyyy') : 'No registrada' }}
            </strong>
          </article>

          <article class="info-card">
            <span>INICIO DEL VOLUNTARIADO</span>
            <strong>
              {{ volunteer.volunteerStartDate ? (volunteer.volunteerStartDate | date:'dd/MM/yyyy') : 'N/A' }}
            </strong>
          </article>

          <article class="info-card">
            <span>¿TIENE WHATSAPP?</span>
            <strong>{{ volunteer.hasWhatsapp ? '✓ Sí (' + (volunteer.whatsappNumber || volunteer.phone) + ')' : 'No' }}</strong>
          </article>

          <article class="info-card">
            <span>CONTACTO SECUNDARIO / EMERGENCIA</span>
            <strong>{{ volunteer.hasSecondaryContact && volunteer.secondaryPhone ? volunteer.secondaryPhone : 'No registrado' }}</strong>
          </article>

          <article class="info-card">
            <span>¿CÓMO SUPO DE ABAQ?</span>
            <strong>{{ volunteer.howDidYouHearAboutAbaq || 'Portal ABAQ' }}</strong>
          </article>
        </div>
      } @else {
        <!-- FORMULARIO REACTIVO DE EDICIÓN PARA ADMIN -->
        <form [formGroup]="volunteerForm" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px;">
          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Nombre completo *
            </label>
            <input
              type="text"
              formControlName="fullName"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Correo electrónico *
            </label>
            <input
              type="email"
              formControlName="mail"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Teléfono principal *
            </label>
            <input
              type="tel"
              formControlName="phone"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              CURP
            </label>
            <input
              type="text"
              formControlName="curp"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px; text-transform: uppercase;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Ocupación / Profesión
            </label>
            <input
              type="text"
              formControlName="occupation"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Fecha de nacimiento *
            </label>
            <input
              type="date"
              formControlName="birthDate"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Fecha de inicio de voluntariado *
            </label>
            <input
              type="date"
              formControlName="volunteerStartDate"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              ¿Cómo supo de ABAQ?
            </label>
            <input
              type="text"
              formControlName="howDidYouHearAboutAbaq"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          <div>
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #475569; margin-bottom: 6px;">
              Teléfono secundario / emergencia
            </label>
            <input
              type="tel"
              formControlName="secondaryPhone"
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>
        </form>
      }
    </section>

    <!-- =========================================
         GRADOS ACADÉMICOS Y ESTUDIOS (DEGREES)
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">FORMACIÓN ACADÉMICA</span>
          <h2>Historial académico y nivel de estudios</h2>
          <p>Grados e instituciones registradas en el expediente.</p>
        </div>
      </div>

      @if (volunteer.degrees && volunteer.degrees.length > 0) {
        <div style="overflow-x: auto; border: 1px solid #e2e8f0; border-radius: 12px; background: #ffffff;">
          <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 13.5px;">
            <thead>
              <tr style="background: #f8fafc; border-bottom: 1.5px solid #cbd5e1;">
                <th style="padding: 12px 18px; font-weight: 800; color: #1e293b;">Nivel</th>
                <th style="padding: 12px 18px; font-weight: 800; color: #1e293b;">Institución</th>
                <th style="padding: 12px 18px; font-weight: 800; color: #1e293b;">Título / Carrera</th>
                <th style="padding: 12px 18px; font-weight: 800; color: #1e293b;">Estado</th>
              </tr>
            </thead>
            <tbody>
              @for (deg of volunteer.degrees; track $index) {
                <tr style="border-bottom: 1px solid #f1f5f9;">
                  <td style="padding: 12px 18px; font-weight: 700; text-transform: capitalize; color: #24366f;">
                    {{ deg.level }}
                  </td>
                  <td style="padding: 12px 18px; color: #334155;">
                    {{ deg.institution || '—' }}
                  </td>
                  <td style="padding: 12px 18px; color: #0f172a; font-weight: 600;">
                    {{ deg.title || '—' }}
                  </td>
                  <td style="padding: 12px 18px;">
                    @if (deg.status === 'completado') {
                      <span style="display: inline-block; padding: 3px 8px; border-radius: 6px; font-size: 12px; font-weight: 700; background: #dcfce7; color: #15803d;">
                        ✓ Completado
                      </span>
                    } @else if (deg.status === 'en_curso') {
                      <span style="display: inline-block; padding: 3px 8px; border-radius: 6px; font-size: 12px; font-weight: 700; background: #eff6ff; color: #1d4ed8;">
                        ⏳ En curso
                      </span>
                    } @else {
                      <span style="display: inline-block; padding: 3px 8px; border-radius: 6px; font-size: 12px; font-weight: 700; background: #fef3c7; color: #b45309;">
                        Trunco
                      </span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div style="padding: 24px; text-align: center; border-radius: 12px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b;">
          No se registraron grados académicos formales en el registro.
        </div>
      }
    </section>

    <!-- =========================================
         PERFIL PERSONAL, TALENTOS Y COMPROMISO (FASE 3)
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">VOCACIÓN Y PERFIL</span>
          <h2>Semblanza, intereses y talentos</h2>
          <p>Perfil vocacional y afinidad al bienestar animal del voluntario.</p>
        </div>
      </div>

      <div class="info-grid">
        <article class="info-card" style="grid-column: 1 / -1;">
          <span>SEMBLANZA / BIO PERSONAL</span>
          <p style="margin: 6px 0 0; font-size: 14px; line-height: 1.6; color: #1e293b; white-space: pre-line;">
            {{ volunteer.bioPersonal || 'Sin semblanza registrada.' }}
          </p>
        </article>

        <article class="info-card">
          <span>INTERESES Y PASIONES</span>
          <strong>{{ volunteer.intereses || 'No especificados' }}</strong>
        </article>

        <article class="info-card">
          <span>TALENTOS Y HABILIDADES ESPECIALES</span>
          <strong>{{ volunteer.talentos || 'No especificados' }}</strong>
        </article>

        <article class="info-card">
          <span>APORTES PRINCIPALES A ABAQ</span>
          <strong>{{ volunteer.aportesAbaq || 'No especificados' }}</strong>
        </article>

        <article class="info-card">
          <span>EXPERIENCIA PREVIA CON ANIMALES</span>
          <strong>{{ volunteer.animalExperience ? '✓ Sí: ' + (volunteer.descExperiencia || 'Convivencia') : 'Sin experiencia previa registrada' }}</strong>
        </article>

        <article class="info-card" style="grid-column: 1 / -1;">
          <span>MOTIVACIÓN PARA UNIRSE A ABAQ</span>
          <p style="margin: 6px 0 0; font-size: 13.5px; color: #334155;">
            {{ volunteer.motivacionAbaq || 'No especificada' }}
          </p>
        </article>
      </div>

      <!-- ACTIVIDADES PRIORIZADAS -->
      @if (volunteer.rankedActivities && volunteer.rankedActivities.length > 0) {
        <div class="ranked-activities-container">
          <div class="ranked-activities-header">
            <div>
              <h3 class="ranked-activities-title">
                🎯 Actividades de voluntariado priorizadas por el aspirante
              </h3>
              <p class="ranked-activities-subtitle">
                Orden de preferencia seleccionado por el voluntario durante la Fase 3 de registro institucional.
              </p>
            </div>
            <span class="ranked-activities-count">
              {{ volunteer.rankedActivities.length }} actividades
            </span>
          </div>

          <div class="ranked-activities-table-wrapper">
            <table class="ranked-activities-table">
              <thead>
                <tr>
                  <th class="col-priority"># Prioridad</th>
                  <th class="col-activity">Actividad de voluntariado priorizada</th>
                </tr>
              </thead>
              <tbody>
                @for (act of volunteer.rankedActivities; track act; let idx = $index) {
                  <tr>
                    <td class="col-priority">
                      <span class="priority-rank-badge">{{ idx + 1 }}</span>
                    </td>
                    <td class="col-activity">
                      <span class="activity-text">{{ getActivityTitle(act) }}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </section>

    <!-- =========================================
         INDUCCIÓN Y REFLEXIONES (FASE 2)
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">PROCESO FORMATIVO</span>
          <h2>Reflexiones de los módulos de inducción</h2>
          <p>Respuestas registradas durante la inducción sobre rescate, valores y misión de ABAQ.</p>
        </div>
      </div>

      @if (hasAnyReflections()) {
        <div style="display: flex; flex-direction: column; gap: 16px;">
          @for (mod of reflectionsList; track mod.id) {
            <div style="padding: 16px 20px; border-radius: 12px; background: #f8fafc; border: 1px solid #e2e8f0;">
              <h4 style="margin: 0 0 10px; font-size: 14.5px; font-weight: 800; color: #24366f;">
                {{ mod.name }}
              </h4>
              @if (mod.data) {
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px; font-size: 13px;">
                  <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                    <span style="display: block; font-weight: 750; color: #059669; margin-bottom: 4px;">❤️ Lo que más llamó mi atención:</span>
                    <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.liked || 'Sin respuesta' }}</p>
                  </div>
                  <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                    <span style="display: block; font-weight: 750; color: #2563eb; margin-bottom: 4px;">⭐ Lo que considero más importante:</span>
                    <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.important || 'Sin respuesta' }}</p>
                  </div>
                  <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                    <span style="display: block; font-weight: 750; color: #d97706; margin-bottom: 4px;">💡 Sugerencia de mejora / innovación:</span>
                    <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.improve || 'Sin respuesta' }}</p>
                  </div>
                </div>
              } @else {
                <span style="font-size: 12.5px; color: #94a3b8; font-style: italic;">Módulo sin respuestas registradas.</span>
              }
            </div>
          }
        </div>
      } @else {
        <div style="padding: 24px; text-align: center; border-radius: 12px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b;">
          Sin reflexiones de inducción registradas para este expediente.
        </div>
      }
    </section>

    <!-- =========================================
         DOCUMENTOS EN LA NUBE (FASE 4)
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">EXPEDIENTE DIGITAL</span>
          <h2>Documentos del expediente en la nube</h2>
          <p>Enlaces y archivos compartidos durante el registro institucional.</p>
        </div>
      </div>

      <div class="info-grid">
        <article class="info-card">
          <span>IDENTIFICACIÓN OFICIAL (INE)</span>
          @if (hasValidDocument(volunteer.cloudUrls?.ine)) {
            <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openDocument(volunteer.cloudUrls?.ine)"
              >
                Abrir en pestaña nueva ↗
              </button>
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openEditDocumentLinkModal('ine')"
              >
                Editar enlace ✏️
              </button>
            </div>
          } @else {
            <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px;">No proporcionado</span>
            <button
              type="button"
              style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
              (click)="openEditDocumentLinkModal('ine')"
            >
              + Agregar enlace
            </button>
          }
        </article>

        <article class="info-card">
          <span>CURRÍCULUM VITAE (CV) / SEMBLANZA</span>
          @if (hasValidDocument(volunteer.cloudUrls?.cv)) {
            <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openDocument(volunteer.cloudUrls?.cv)"
              >
                Abrir en pestaña nueva ↗
              </button>
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openEditDocumentLinkModal('cv')"
              >
                Editar enlace ✏️
              </button>
            </div>
          } @else {
            <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px;">No proporcionado</span>
            <button
              type="button"
              style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
              (click)="openEditDocumentLinkModal('cv')"
            >
              + Agregar enlace
            </button>
          }
        </article>

        <article class="info-card">
          <span>COMPROBANTE DE DOMICILIO O ESTUDIOS</span>
          @if (hasValidDocument(volunteer.cloudUrls?.comprobante)) {
            <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openDocument(volunteer.cloudUrls?.comprobante)"
              >
                Abrir en pestaña nueva ↗
              </button>
              <button
                type="button"
                style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                (click)="openEditDocumentLinkModal('comprobante')"
              >
                Editar enlace ✏️
              </button>
            </div>
          } @else {
            <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px;">No proporcionado</span>
            <button
              type="button"
              style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
              (click)="openEditDocumentLinkModal('comprobante')"
            >
              + Agregar enlace
            </button>
          }
        </article>
      </div>
    </section>

    <!-- =========================================
         CONSTANCIA OFICIAL DE ACEPTACIÓN
    ========================================== -->
    @if (volunteer.accountStatus === 'active') {
      <section class="detail-section">
        <div class="section-header">
          <div>
            <span class="section-eyebrow">DOCUMENTO OFICIAL</span>
            <h2>Constancia oficial de aceptación</h2>
            <p>Constancia oficial emitida por ABAQ con sello criptográfico HMAC-SHA256.</p>
          </div>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 20px 24px; border-radius: 14px; background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); border: 1.5px solid #bfdbfe; flex-wrap: wrap;">
          <div style="display: flex; align-items: center; gap: 16px;">
            <div style="width: 52px; height: 52px; border-radius: 12px; background: #2563eb; color: #ffffff; display: flex; align-items: center; justify-content: center; font-size: 26px;">
              📄
            </div>
            <div>
              <h3 style="margin: 0; font-size: 16px; font-weight: 800; color: #1e3a8a;">
                Constancia de Aceptación y Felicitación · Voluntariado General
              </h3>
              <p style="margin: 4px 0 0; font-size: 13px; color: #2563eb;">
                Folio: <strong>{{ volunteer.folio }}</strong> · Verificable en línea con QR institucional
              </p>
            </div>
          </div>

          <button
            type="button"
            style="padding: 12px 20px; border-radius: 10px; background: #1d4ed8; color: #ffffff; border: none; font-weight: 750; font-size: 13.5px; cursor: pointer;"
            (click)="openDocument(volunteer.cartaAceptacion)"
          >
            Ver y Descargar Constancia ↗
          </button>
        </div>
      </section>
    }

    <!-- =========================================
         CONSENTIMIENTOS NORMATIVOS (FASE 4)
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">NORMATIVA Y CUMPLIMIENTO</span>
          <h2>Consentimientos y aceptación de términos</h2>
          <p>Condiciones y términos validados por el voluntario durante el registro. Haz clic en cualquiera para abrir el documento en otra pestaña.</p>
        </div>
      </div>

      <div class="consent-grid">
        <a
          [href]="getLegalDocUrl('reglamento')"
          (click)="openLegalDoc('reglamento', $event)"
          target="_blank"
          rel="noopener noreferrer"
          class="consent-doc-link"
          title="Abrir Reglamento General Interno en otra pestaña"
        >
          <div class="consent-left">
            <span class="consent-status-icon">{{ volunteer.consents?.reglamento ? '✅' : '❌' }}</span>
            <span class="consent-title">Reglamento General Interno</span>
          </div>
          <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
        </a>

        <a
          [href]="getLegalDocUrl('privacidad')"
          (click)="openLegalDoc('privacidad', $event)"
          target="_blank"
          rel="noopener noreferrer"
          class="consent-doc-link"
          title="Abrir Aviso de Privacidad Integral en otra pestaña"
        >
          <div class="consent-left">
            <span class="consent-status-icon">{{ volunteer.consents?.privacidad ? '✅' : '❌' }}</span>
            <span class="consent-title">Aviso de Privacidad Integral</span>
          </div>
          <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
        </a>

        <a
          [href]="getLegalDocUrl('etica')"
          (click)="openLegalDoc('etica', $event)"
          target="_blank"
          rel="noopener noreferrer"
          class="consent-doc-link"
          title="Abrir Código de Ética y Conducta en otra pestaña"
        >
          <div class="consent-left">
            <span class="consent-status-icon">{{ volunteer.consents?.etica ? '✅' : '❌' }}</span>
            <span class="consent-title">Código de Ética y Conducta</span>
          </div>
          <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
        </a>

        <a
          [href]="getLegalDocUrl('incognito')"
          (click)="openLegalDoc('incognito', $event)"
          target="_blank"
          rel="noopener noreferrer"
          class="consent-doc-link"
          title="Abrir Permiso de Difusión Institucional en otra pestaña"
        >
          <div class="consent-left">
            <span class="consent-status-icon">{{ volunteer.consents?.incognito ? '✅' : '❌' }}</span>
            <span class="consent-title">Permiso de Difusión Institucional</span>
          </div>
          <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
        </a>

        <a
          [href]="getLegalDocUrl('consentimiento')"
          (click)="openLegalDoc('consentimiento', $event)"
          target="_blank"
          rel="noopener noreferrer"
          class="consent-doc-link"
          title="Abrir Consentimiento Voluntario Expreso en otra pestaña"
        >
          <div class="consent-left">
            <span class="consent-status-icon">{{ volunteer.consents?.consentimiento ? '✅' : '❌' }}</span>
            <span class="consent-title">Consentimiento Voluntario Expreso</span>
          </div>
          <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
        </a>
      </div>
    </section>

    <!-- =========================================
         REDES SOCIALES
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">COMUNIDAD</span>
          <h2>Redes sociales y canales de contacto</h2>
          <p>Cuentas registradas para comunicación institucional y difusión.</p>
        </div>
      </div>

      <div class="social-grid">
        <article class="social-card">
          <div class="social-icon fb" title="Facebook">
            <svg class="lucide lucide-facebook" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </div>
          <div>
            <span>FACEBOOK</span>
            <strong>{{ volunteer.socialMedia.facebook || 'Sin cuenta' }}</strong>
          </div>
        </article>

        <article class="social-card">
          <div class="social-icon ig" title="Instagram">
            <svg class="lucide lucide-instagram" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
            </svg>
          </div>
          <div>
            <span>INSTAGRAM</span>
            <strong>{{ volunteer.socialMedia.instagram || 'Sin cuenta' }}</strong>
          </div>
        </article>

        <article class="social-card">
          <div class="social-icon tk" title="TikTok">
            <svg class="lucide lucide-tiktok" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
            </svg>
          </div>
          <div>
            <span>TIKTOK</span>
            <strong>{{ volunteer.socialMedia.tiktok || 'Sin cuenta' }}</strong>
          </div>
        </article>

        <article class="social-card">
          <div class="social-icon x" title="X (Twitter)">
            <svg class="lucide lucide-twitter" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l11.733 16h4.267l-11.733 -16z"/>
              <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/>
            </svg>
          </div>
          <div>
            <span>X</span>
            <strong>{{ volunteer.socialMedia.x || 'Sin cuenta' }}</strong>
          </div>
        </article>

        <article class="social-card">
          <div class="social-icon yt" title="YouTube">
            <svg class="lucide lucide-youtube" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/>
              <polygon points="10 15 15 12 10 9 10 15"/>
            </svg>
          </div>
          <div>
            <span>YOUTUBE</span>
            <strong>{{ volunteer.socialMedia.youtube || 'Sin cuenta' }}</strong>
          </div>
        </article>

        <article class="social-card">
          <div class="social-icon li" title="LinkedIn">
            <svg class="lucide lucide-linkedin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect width="4" height="12" x="2" y="9"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </div>
          <div>
            <span>LINKEDIN</span>
            <strong>{{ volunteer.socialMedia.linkedin || 'Sin cuenta' }}</strong>
          </div>
        </article>
      </div>
    </section>

    <!-- =========================================
         ACTIVIDADES
    ========================================== -->
    <section class="detail-section">
      <div class="section-header">
        <div>
          <span class="section-eyebrow">PARTICIPACIÓN</span>
          <h2>Actividades asignadas al voluntario</h2>
          <p>Programas y actividades en las que este voluntario colabora.</p>
        </div>
        <span class="activity-count">
          {{ volunteer.assignedActivities.length }}
          {{ volunteer.assignedActivities.length === 1 ? 'actividad' : 'actividades' }}
        </span>
      </div>

      @if (volunteer.assignedActivities.length) {
        <div class="activities-list">
          @for (activity of volunteer.assignedActivities; track activity.activityRef) {
            <article class="activity-card">
              <div class="activity-main">
                <strong>{{ activity.title }}</strong>
                <span>{{ activity.type || 'Actividad ABAQ' }}</span>
                @if (activity.interactionFolio) {
                  <div class="activity-folio-row">
                    <app-folio-pill
                      [folio]="activity.interactionFolio"
                      [interactionType]="activity.interactionType || 'OP'"
                      [showHours]="false"
                    ></app-folio-pill>
                  </div>
                }
              </div>
              <div class="activity-status">
                {{ activity.status }}
              </div>
            </article>
          }
        </div>
      } @else {
        <div class="empty-activities">
          <strong>Sin actividades registradas</strong>
          <span>Este voluntario aún no cuenta con actividades asignadas en la plataforma.</span>
        </div>
      }
    </section>

    <!-- =========================================
         MODAL PARA EDICIÓN DE ENLACES EN LA NUBE
    ========================================== -->
    @if (showDocumentLinkModal) {
      <div class="modal-backdrop" (click)="closeDocumentLinkModal()">
        <div class="modal-window" (click)="$event.stopPropagation()" style="max-width: 520px; background: white; padding: 24px; border-radius: 16px; box-shadow: 0 10px 25px rgba(0,0,0,0.2);">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
            <h3 style="margin: 0; font-size: 18px; font-weight: 800; color: #1e293b;">
              {{ editingDocumentTitle }}
            </h3>
            <button
              type="button"
              style="border: none; background: transparent; font-size: 20px; cursor: pointer; color: #64748b;"
              (click)="closeDocumentLinkModal()"
            >
              ✕
            </button>
          </div>

          <p style="margin: 0 0 16px; font-size: 13px; color: #64748b; line-height: 1.4;">
            {{ editingDocumentSubtitle }}
          </p>

          <div style="margin-bottom: 16px;">
            <label style="display: block; font-size: 12.5px; font-weight: 750; color: #334155; margin-bottom: 6px;">
              Enlace URL (Google Drive / OneDrive)
            </label>
            <input
              type="url"
              [(ngModel)]="editingDocumentUrl"
              placeholder="https://drive.google.com/... o https://1drv.ms/..."
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px;"
            />
          </div>

          @if (documentLinkError) {
            <div style="margin-bottom: 14px; padding: 10px 14px; border-radius: 8px; background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; font-size: 12.5px;">
              {{ documentLinkError }}
            </div>
          }

          <div style="display: flex; justify-content: flex-end; gap: 10px;">
            <button
              type="button"
              style="padding: 9px 16px; border-radius: 8px; background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; font-weight: 700; cursor: pointer;"
              (click)="closeDocumentLinkModal()"
              [disabled]="isSavingDocumentLink"
            >
              Cancelar
            </button>
            <button
              type="button"
              style="padding: 9px 18px; border-radius: 8px; background: #2563eb; color: #ffffff; border: none; font-weight: 750; cursor: pointer;"
              (click)="saveDocumentLink()"
              [disabled]="isSavingDocumentLink"
            >
              @if (isSavingDocumentLink) {
                Guardando...
              } @else {
                Guardar enlace
              }
            </button>
          </div>
        </div>
      </div>
    }

  }

</div>

<app-inactivate-volunteer-modal
  *ngIf="showInactivateModal && volunteer"
  [targetId]="volunteer.id"
  [targetName]="volunteer.fullName || ''"
  [targetFolio]="volunteer.folio || ''"
  targetRole="volunteer"
  (confirmed)="handleInactivateConfirmed($event)"
  (cancelled)="closeInactivateModal()"
>
</app-inactivate-volunteer-modal>

